import React from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import { withStyles, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, FormControlLabel } from "@material-ui/core";
import Checkbox from "./CustomCheckbox";
import t from "../../languages/pl";

const useStyles = theme => ({
    dialogActions: {
        display: 'flex',
        justifyContent: "space-between",
        alignItems: "center"
    },
    checkbox: {
        color: "grey"
    },
    formControl: {
        marginLeft: theme.spacing(1)
    },
    backdrop: {
        background: "rgba(255,255,255,0.7)"
    }
});

const InformationDialog = props => {
    const { classes, open, onClose, content, title, children, size = "xs", omitCheckbox = false } = props;
    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth={size}
            style={{zIndex: 2001}}
            BackdropProps={{
                classes: {root: classes.backdrop}
            }}
        >
            <DialogTitle>
                {title}
            </DialogTitle>
            <DialogContent>
                {
                    !children
                    ?
                    <Typography variant="body1">
                    {content}
                    </Typography>
                    :
                    children
                }
            </DialogContent>
            <DialogActions className={clsx({[classes.dialogActions]: omitCheckbox})}>
                {
                    omitCheckbox
                    &&
                    <FormControlLabel
                        className={classes.formControl}
                        label={t.dontShowAgain}
                        control={<Checkbox className={classes.checkbox} />}
                     />
                }
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={onClose}
                >
                    {t.close}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

InformationDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    onClose: PropTypes.func,
    title: PropTypes.string,
    content: PropTypes.string,
    size: PropTypes.string,
    omitCheckbox: PropTypes.bool,
    children: PropTypes.node
};

export default withStyles(useStyles)(InformationDialog);
